<template>
    <Modal
      v-model="value"
      :width="width"
      :scrollable="false"
      :fullscreen="fullscreen"
      :mask-closable="false"
      :title="modalTitle"
      :class-name="name">
      <Spin fix v-show="loading"></Spin>

      <FormTemplate
        ref="template"
        :loading.sync="loading"
        :submitting.sync="submitting"
        :selection="selection"
        :currentStep="currentStep"
        :okText="okText"
        :errorTip="errorTip"
        @fail="handleFail"
        @error="handleError"
        @success="handleSuccess"
        @closeModal="closeModal"></FormTemplate>
  
      <div class="other_footer" slot="footer">
        <Button
        v-if="currentStep === 1"
        type="text"
        size="large"
        @click="value = false">取消</Button>
        <Button
          v-if="steps > 0 ? currentStep === steps : okText"
          type="primary"
          size="large"
          :loading="submitting"
          @click="modalOk">{{okText}}</Button>
          <!-- <Button
          v-if="currentStep === 1"
          type="text"
          size="large"
          @click="value = false">关闭</Button> -->
      </div>
    </Modal>
  </template>
  
  <script type="text/javascript">
  export default {
    data () {
      return {
        timer: null,
        value: false,
        loading: false,
        submitting: false,
        currentStep: 1
      }
    },
    props: {
      fullscreen: Boolean,
      title: String,
      hasfooter: Boolean,
      name: [String,Number],
      onSuccess: Function,
      onError: Function,
      successTip: {
        type: Boolean,
        default: true
      },
      errorTip: {
        type: Boolean,
        default: true
      },
      okText: {
        type: [String, Boolean],
        default: '确定'
      },
      width: [String, Number],
      // 传递给子组件
      selection: Object,
      steps: Number,
      afterTitle: String
    },
    computed: {
      modalTitle () {
        const { title } = this
        return title
      }
    },
    methods: {
      closeModal() {
        this.value = false
      },
      handleFail (reason) {
        if (typeof reason === 'string') this.$Message.error(reason)
        this.value = false
      },
      handleError (data) {
        // if(this.errorTip) {
        //   this.$Message.error(data.msg)
        // }
        if (this.onError) this.onError(data)
      },
      handleSuccess (data) {
        // if (this.successTip) {
        //   //操作成功显示
        //   this.$Message.success(data.msg)
        // }
        if (this.onSuccess) this.onSuccess(data)
        this.value = false
      },
      stepNext () {
        this.$refs.template._validate().then(() => {
          this.currentStep++
        }).catch(error => {
          this.$Message.error(error.toString())
        })
      },
      modalOk () {
        this.$refs.template._confirm()
      },
      // 销毁实例并移除元素
      destroyElement () {
        if (this.timer) {
          window.clearTimeout(this.timer)
          this.timer = null
        }
        this.$destroy(true)
        this.$el.parentNode.removeChild(this.$el)
      }
    },
    watch: {
      value (bool) {
        if (!bool) {
          this.timer = window.setTimeout(this.destroyElement, 300)
        }
      },
      '$route.name': {
        immediate: true,
        handler() {
          this.value = false
        },
      }
    }
  }
  </script>
  